import React, { useEffect, useState } from 'react';
import { Typography } from 'antd';
import { getMasterFranchiseConfigurations } from '@/services/MasterFranchiseConfigurationService';
import getCurrencyExchangeRates from '@/services/CurrencyExchangeService';
import useLocalStorage from '@/hooks/useLocalStorage';

const LOCAL_STORAGE_KEY = 'currency_exchange_usd_mxn';

const CurrencyExchangeDisplay: React.FC = () => {
  const [rate, setRate] = useLocalStorage({ key: LOCAL_STORAGE_KEY });
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    getMasterFranchiseConfigurations({ masterFranchiseId: 1 })
      .then((configs) => {
        const token = configs.find(c => c.key === 'mexican_bank_token')?.value;
        if (!token) {
          setVisible(false);
          return;
        }
        setVisible(true);
        return getCurrencyExchangeRates();
      })
      .then((exchange) => {
        if (!exchange) return;
        setRate(exchange.exchangeRate);
      })
      .catch(() => {
        // Si el servicio falla, se mantiene el valor guardado en localStorage
        setVisible(rate != null);
      });
  }, []);

  if (!visible || rate == null) return null;

  return (
    <Typography.Text>
      {'USD '}
      <Typography.Text strong>
        {`$${Number(rate).toFixed(2)} MXN`}
      </Typography.Text>
    </Typography.Text>
  );
};

export default CurrencyExchangeDisplay;
